<template>
    <div>

        <!-- main content -->
        <div id="main-container">

            <!-- expand and compress icons -->
            <div id="fullscreen-button" class="presentation-app-button" @click="GoInFullscreen()"><i class="fa-solid fa-expand"></i></div>
            <div id="exit-button" class="presentation-app-button" @click="GoOutFullscreen()"><i class="fa-solid fa-compress"></i></div>

            <!-- image -->
            <div id="image-container">
                <img id="lifechain-image" src="../assets/images/New LifeChain Image.jpg">
            </div>

        </div>
        <!-- END main content -->

    </div>
</template>
 
<script>
    export default {
        name: "Presentation",
        data() {
            return {
                test: "test data"
            };
        },    
        mounted() {
            // Display core vue app element
            const appElement = document.getElementById('app');
            appElement.style.display = 'block';
        },
        created() {

        },    
        methods: {
            GoInFullscreen() {
                document.getElementById("fullscreen-button").style.display = 'none';
                document.getElementById("exit-button").style.display = 'block';

                var element = document.getElementById("main-container");

                var img = document.getElementById("lifechain-image");
                img.classList.add("margin-for-fullscreen");
                
                if(element.requestFullscreen)
                    element.requestFullscreen();
                else if(element.mozRequestFullScreen)
                    element.mozRequestFullScreen();
                else if(element.webkitRequestFullscreen)
                    element.webkitRequestFullscreen();
                else if(element.msRequestFullscreen)
                    element.msRequestFullscreen();
            },
            GoOutFullscreen() {
                document.getElementById("fullscreen-button").style.display = 'block';
                document.getElementById("exit-button").style.display = 'none';

                var img = document.getElementById("lifechain-image");
                img.classList.remove("margin-for-fullscreen");

                if(document.exitFullscreen)
                    document.exitFullscreen();
                else if(document.mozCancelFullScreen)
                    document.mozCancelFullScreen();
                else if(document.webkitExitFullscreen)
                    document.webkitExitFullscreen();
                else if(document.msExitFullscreen)
                    document.msExitFullscreen();
            },
        },
    };
</script>

<style>
    #exit-button {
        display: none;
        color: white;
        margin-top: 10px;
    }

    .presentation-app-button {
        position: absolute;
        top: 0;
        right: 0;
        margin: 20px;   
    }

    #lifechain-image {
        width: 100%;
    }

    .margin-for-fullscreen {
        margin-top: 35px;
    }
</style>